<template>
    <div class="MessageContent">
        <v-spacer v-if="!isUser"></v-spacer>
        <div style="background: #fff; border-radius: 5px; overflow: hidden" v-if="!!content.url">
            <img
                    :src="content.url"
                    alt="[User send ticker]"
                    style="max-height: 300px; max-width: 100%; display: block; background-color: #f7f7fc"
            />
        </div>
        <div v-else class="message-text" :class="isUser ? 'user' : 'bot'">
            [User send sticker]
            <pre v-show="showViewMore">{{ JSON.stringify(content, null, 4) }}</pre>
            <span  @click="toggleViewMore" class="view-more">
                {{ showViewMore?$t('close'):$t('details') }}
            </span>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentSticker",
    extends: MessageContent,
    mounted() {
        this.showViewMore = false;
    },
}

</script>
<style scoped lang="scss" src="../../style/message-box.scss"></style>
